// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audioPanel_player__25gZm {\n  width: calc(100% - 350px);\n  min-width: 350px; }\n", ""]);
// Exports
exports.locals = {
	"player": "audioPanel_player__25gZm"
};
module.exports = exports;
